export default {
  methods: {
    mapLayerBikeparkSigns2Add() {
      this.initPollBikeparkSigns2();
      this.map.addSource("bikepark-signs2-source", {
        type: "geojson",
        data: this.$store.state.mapLayers.bikepark.layers.signs2.geojson
      });

      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/bikepark/signs/bp_signs.png",
        (error, image) => {
          this.map.addImage("icon-bikepark-signs-2", image);
          this.map.addLayer({
            filter: [
              "all",
              ["!=", "hidden", "true"],
              [
                "any",
                ["==", "sign_loc", "Wooden Sign Board"],
                ["==", "sign_loc", "Trail Hub"],
                ["==", "sign_loc", "Trail Head"],
                ["==", "sign_loc", "Crossing or Merge"]
              ]
            ],
            id: "bikepark-signs-2",
            type: "symbol",
            source: "bikepark-signs2-source",
            layout: {
              "icon-image": "icon-bikepark-signs-2",
              "icon-size": 0.25,
              "icon-allow-overlap": true,
              "text-allow-overlap": true
            }
          });

          this.map.moveLayer("bikepark-signs-2", "marker-layer-points");
        }
      );
    },
    mapLayerBikeparkSigns2Remove() {
      this.cancelPollBikeparkSigns2();
      this.map.removeImage("icon-bikepark-signs-2");
      this.map.removeLayer("bikepark-signs-2");
      this.map.removeSource("bikepark-signs2-source");
    },

    initPollBikeparkSigns2() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/bikepark/signs",
        dept: "bikepark",
        layer: "signs2",
        token: this.computedAuthToken
      });
      this.pollBikeparkSigns2Interval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url: "https://api2.alchemymapping.com/vail/whistler/bikepark/signs",
          dept: "bikepark",
          layer: "signs2",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    cancelPollBikeparkSigns2() {
      this.pollBikeparkSigns2Interval = clearInterval(
        this.pollBikeparkSigns2Interval
      );
    }
  },
  computed: {
    computedBikeparkSigns2GeoJson() {
      if (this.$store.state.mapLayers.bikepark.layers.signs2.geojson.features) {
        const signs = this.$store.state.mapLayers.bikepark.layers.signs2.geojson
          .features;
        let filteredSigns = signs.filter(
          item => item.properties.hidden != "true"
        );
        return filteredSigns;
      }
    },
    computedBikeparkSigns2MapVisibility() {
      return this.$store.state.mapLayers.bikepark.layers.signs2.visibility
        .mapView;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedInterval() {
      return this.$store.state.general.intervalLow;
    }
  },
  watch: {
    "$store.state.mapLayers.bikepark.layers.signs2.geojson": {
      handler() {
        if (this.computedBikeparkSigns2GeoJson) {
          this.mapLayerBikeparkSigns2Remove();
          this.mapLayerBikeparkSigns2Add();
        }
      }
    },
    "$store.state.mapLayers.bikepark.layers.signs2.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerBikeparkSigns2Add();
      } else {
        this.mapLayerBikeparkSigns2Remove();
      }
    }
  },
  beforeDestroy() {
    this.cancelPollBikeparkSigns2();
  }
};
